/**
 * REMOVED: This file previously contained client-side encryption logic that used a hardcoded secret key.
 *
 * Security Issue Fixed:
 * - Client-side encryption with hardcoded keys provides no security (keys are exposed in the bundle)
 * - Session management is now handled securely via JWT HttpOnly cookies set by the backend
 * - The backend already provides authentication via /auth/login and /auth/refresh endpoints
 *
 * Session Persistence Strategy:
 * - Authentication state persists in HttpOnly cookies (managed by the browser)
 * - On app load, the INIT action triggers checkSession effect in auth.effects.ts
 * - The checkSession effect calls /user/me endpoint to verify session and restore user state
 * - No sensitive data is stored in plaintext or encrypted in sessionStorage/localStorage
 */

import { ActionReducer } from '@ngrx/store';

/**
 * Identity metareducer - passes state through unchanged
 * Session state is now managed entirely server-side via HttpOnly JWT cookies
 */
export const metaReducerSessionStorage = (
  reducer: ActionReducer<any>
): ActionReducer<any> => {
  return (state, action) => {
    return reducer(state, action);
  };
};
